/**
 * ZeitschritteSection Component
 * Renders Zeitschritte section in PDF
 */

import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { ZeitschritteData } from '@/types/common';
import { styles } from '../styles';
import { PDFTable, PDFTableRow } from './PDFTable';

interface ZeitschritteSectionProps {
  zeitschritte: ZeitschritteData;
}

export const ZeitschritteSection: React.FC<ZeitschritteSectionProps> = ({ zeitschritte }) => {
  const { t } = useTranslation('pdfReport');
  return (
    <View style={styles.section}>
      <Text style={styles.subtitle}>{t('timeSteps.section')}</Text>

      <PDFTable>
        <PDFTableRow label={t('timeSteps.input')} value={zeitschritte.eingabe} isEven />
        <PDFTableRow label={t('timeSteps.output')} value={zeitschritte.ausgabe} isEven={false} />
        <PDFTableRow label={t('timeSteps.stepWidth')} value={zeitschritte.zeitschrittweite} isEven />
        <PDFTableRow label={t('timeSteps.offset')} value={zeitschritte.offset} isEven={false} isLast />
      </PDFTable>
    </View>
  );
};
